// extracted by mini-css-extract-plugin
module.exports = {"medication":"Medication_medication__5oMdN","btnWrapper":"Medication_btnWrapper__3nOx7"};